import { render } from "./OrderConfirm.vue?vue&type=template&id=c3f91082&scoped=true"
import script from "./OrderConfirm.vue?vue&type=script&lang=js"
export * from "./OrderConfirm.vue?vue&type=script&lang=js"

import "./OrderConfirm.vue?vue&type=style&index=0&id=c3f91082&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-c3f91082"

export default script